import React, { useState, useEffect } from "react";
import axios from "axios";
import BasicTable from "./showTable";
import { Backdrop, CircularProgress } from "@mui/material";
import CloverSalesApis from "../config/cloverSalesApis";

const FileUploadToBackend = () => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const startYear = 2020;
  const [period, setPeriod] = useState("month");
  const [selectedMonth, setSelectedMonth] = useState(1);



  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [loadingButton, setLoadingButton] = useState("");
  const [intRitasStoreID, setIntRitasStoreID] = useState(null); // Store ID for the table
  const [uploadSuccess, setUploadSuccess] = useState(false); // Track upload success
  const [noDataMessage, setNoDataMessage] = useState(""); // Message for no data case
  
  const [selectedWeek, setSelectedWeek] = useState("");
  const [weeks, setWeeks] = useState([]);
  const [previewData, setPreviewData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  //handle year change
  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);
    setSelectedMonth(1); // January of selected year
  };

  const years = [];
  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }





  // Set current month/year as default on component mount
  // useEffect(() => {
  //   const now = new Date();
  //   const currentMonth = now.toISOString().slice(0, 7); // "YYYY-MM"
  //   setSelectedMonth(currentMonth);
  // }, []);

  useEffect(() => {
    if (period === "week" && selectedYear) {
      fetchWeeksFromAPI(selectedYear);
    }
  }, [period, selectedYear]);

  const fetchWeeksFromAPI = async (year) => {
    try {
      const url = `${CloverSalesApis.fetchYearWeeks}?year=${encodeURIComponent(year)}`;
      const response = await fetch(
                      url,
                      {
                          method: "GET",
                          headers: {
                              "Content-Type": "application/json",
                          }
                      }
                  );

      if (!response.ok) {
        throw new Error(`API error: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      const weeks_data = result.data.data;
      setWeeks(weeks_data);
    } catch (error) {
      console.error("Failed to fetch weeks:", error);
    }
  };
  

  const handleMonthChange = (e) => {
    const month_number = e.target.value; // month in number
    setSelectedMonth(month_number);   // Update the month in number
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setMessage(""); // Clear any previous message
    setNoDataMessage(""); // Clear no-data message
  };

  const uploadToBackend = async () => {
    if (!file) {
      setMessage("Please select a file to upload.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", file);

      const queryParams = new URLSearchParams();
      queryParams.append("year", selectedYear);
      queryParams.append("period", period);

      if (period === "month") {
        queryParams.append("selectedMonth", selectedMonth);
      } else if (period === "week") {
        console.log("week is:",selectedWeek);
        queryParams.append("selectedWeek", selectedWeek); // Will create an array-like param
      };     

      const url = `${CloverSalesApis.processExcel}?${queryParams.toString()}`;

      setLoadingButton("FileUpload");
      const response = await axios.post(
        url,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const intRitasStoreID = response.data["intRitasStoreID"];
      const result_week = response.data["week"];
      setIntRitasStoreID(intRitasStoreID);

      if (response.data["message"].length !== 0) {
        const fileresponse = await axios.get(
          CloverSalesApis.previewExcelData,
          {
            params: { intRitasStoreID: intRitasStoreID, year:selectedYear, period: period, selectedMonth: selectedMonth, selectedWeek: result_week },
            headers: { "Content-Type": "application/json" },
          }
        );
        
        console.log("file response is:",fileresponse.data);
        console.log("file response data is :",fileresponse.data.data);
        if (fileresponse.data){
        if (fileresponse.data.data.length > 0) {
          setUploadSuccess(true);
          setPreviewData(fileresponse.data.data); // Set the preview data for the table
          setStartDate(fileresponse.data.startDate);
          setEndDate(fileresponse.data.endDate);
        } else {
          
          setNoDataMessage("No data available to display. Please check your file and try again.");
          setUploadSuccess(false);
        }
      }
    }
    } catch (error) {
      console.error("Error uploading file:", error);
      setMessage("Failed to upload the file.");
    } finally {
      setLoadingButton("");
    }
  };

  if (uploadSuccess) {
    return <BasicTable intRitasStoreID={intRitasStoreID} setUploadSuccess={setUploadSuccess} setFile={setFile} previewData = {previewData} startDate={startDate} endDate={endDate} />;
  } else {
    return (
      <div className="py-6 mt-16">
        <header>
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
              Non-Clover Sales Update
            </h1>
          </div>
        </header>
        <main>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loadingButton === "FileUpload"}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 px-4 py-8 sm:px-0 bg-white dark:bg-gray-800 rounded shadow px-6 py-4 flex flex-col items-center space-y-6">
            <p className="text-gray-500 text-center">Select Month/Week(s) for which you want to upload data.</p>
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
              {/* Select Year */}
              <div>
                <label htmlFor="year-select" className="block text-sm font-medium text-gray-700 mb-1">
                  Select Year
                </label>
                <select
                  id="year-select"
                  value={selectedYear}
                  onChange={handleYearChange}
                  className="block w-40 px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              {/* Period Radio Buttons  */}
              <div className="flex items-center space-x-6">
                <div className="flex items-center">
                  <input
                    className="form-check-input text-blue-600 focus:ring-blue-500"
                    type="radio"
                    name="period"
                    id="month"
                    value="month"
                    checked={period === "month"}
                    onChange={(e) => setPeriod(e.target.value)}
                  />
                  <label htmlFor="month" className="ml-2 text-sm text-gray-700">
                    Month
                  </label>
                </div>
                <div className="flex items-center">
                  <input
                    className="form-check-input text-blue-600 focus:ring-blue-500"
                    type="radio"
                    name="period"
                    id="week"
                    value="week"
                    checked={period === "week"}
                    onChange={(e) => setPeriod(e.target.value)}
                  />
                  <label htmlFor="week" className="ml-2 text-sm text-gray-700">
                    Week
                  </label>
                </div>
              </div>
            </div>

            {/* Conditionally render date picker */}
            {period === "month" && (
              <div className="mt-3 flex items-center space-x-2" id="datePickerContainer">
                <label
                  htmlFor="monthPicker"
                  className="text-sm font-medium text-gray-700 whitespace-nowrap"
                >
                  Select Month:
                </label>
                <select
                  id="monthPicker"
                  name="monthPicker"
                  className="w-full max-w-xs px-4 py-2 text-sm border border-gray-300 rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                >
                  {months.map((month, index) => (
                    <option key={index} value={index + 1}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {period === "week" && (
              <div className="mt-3 flex items-center gap-4" id="weekDropdownContainer">
              <label htmlFor="weekDropdown" className="text-sm font-medium text-gray-700 whitespace-nowrap">
                Select Week:
              </label>
              <select
                id="weekDropdown"
                className="block w-full max-w-xs px-4 py-2 text-sm border border-gray-300 rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
                value={selectedWeek}
                onChange={(e) => setSelectedWeek(e.target.value)}
              >
                <option value="">-- Select a week --</option>
                {weeks.map((week, index) => (
                  <option key={index} value={week.label}>
                    {week.label}
                  </option>
                ))}
              </select>
            </div>                  
            )}

            <p className="text-gray-500 text-center">Select an Excel file to upload and preview.</p>
            {/* File Input */}
            <div className="w-1/2">
              <input
                type="file"
                accept=".xls,.xlsx"
                onChange={handleFileChange}
                className="w-full border border-gray-300 rounded px-4 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>

            {/* Upload Button */}
            <div className="w-1/2">
              <button
                onClick={uploadToBackend}
                className={`w-full px-4 py-2 rounded-lg font-semibold text-white transition ${loadingButton === "FileUpload"
                  ? "bg-primary/70 cursor-not-allowed"
                  : "bg-primary hover:bg-primary-dark"
                  }`}
                disabled={loadingButton === "FileUpload"}
              >
                {loadingButton === "FileUpload" ? "Uploading..." : "Upload"}
              </button>
            </div>

            {/* Status Messages */}
            {message && (
              <p className={`text-sm font-medium ${message.includes("success")
                  ? "text-green-600"
                  : "text-red-600"
                  }`}>
                {message}
              </p>
            )}

            {/* No Data Messages */}
            {noDataMessage && (
              <p className="text-sm font-medium text-red-600">{noDataMessage}</p>
            )}
          </div>
        </main>
      </div>
    );
  }
};

export default FileUploadToBackend;
